module.exports = __webpack_public_path__ + "img/视频封面2.28a7fe30.png";